
import { ErrResponseType, RESET_ERROR, ERROR_OCCURED, NETWORK_ERROR_OCCURED, ResetErrorAction, DataErrorAction, NetworkErrorAction } from './types';

export const resetError = (): ResetErrorAction => ({
  type: RESET_ERROR,
});

export const dataError = (err:ErrResponseType): DataErrorAction => ({
  type: ERROR_OCCURED,
  err,
});

export const networkError = (err: ErrResponseType): NetworkErrorAction => ({
  type: NETWORK_ERROR_OCCURED,
  err,
});


